<template>
  <v-flex>
      <v-stepper v-model="currentStep">
        <v-stepper-header>
          <v-stepper-step :complete="stepOneComplete" step="1">
              {{stepOneTargetHeader}}
              <small>{{stepOneChoice}}</small>
          </v-stepper-step>  
          <v-divider></v-divider>  
          <v-stepper-step :complete="stepTwoComplete" step="2">
              Point of interest
              <small>{{stepTwoChoice}}</small>
          </v-stepper-step>  
          <v-divider></v-divider>  
          <v-stepper-step :complete="stepThreeComplete" step="3">
              Event(s) instellen
              <small>{{stepThreeChoice}}</small>
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="4">
              Tijdsperiode instellen
              <small>{{stepFourChoice}}</small>
          </v-stepper-step>        
        </v-stepper-header>  
    <!-- STEP 1: ASSET SELECTION ---------------------------------------------------------------------------------------->
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-layout row>
              <v-flex>
                <v-flex xs12 mb-2>
                  <h4>Stap 1: {{stepOneTarget}}</h4>
                </v-flex>     
                <v-flex xs12 v-if="selectedMode=='choose'">                              
                      <v-radio-group v-model="selectedMode" :mandatory="false">
                        <v-radio value="asset"  label="Een Asset koppelen"></v-radio>
                        <v-radio value="assetGroup"  label="Een Assetgroep koppelen"></v-radio>
                      </v-radio-group>              
                </v-flex>
                <v-flex xs12 v-if="selectedMode=='asset'">
                  <v-text-field
                      @keyup="search(vm)"
                      v-model="searchMixin.searchText"
                      prepend-inner-icon="fas fa-search"
                      dense
                      label="Zoek een asset"
                      solo>                    
                  </v-text-field>         
                  <v-data-table :headers="gridHeaders" :items="assets" hide-actions>
                      <template slot="items" slot-scope="props">
                          <tr @click="selectAsset(props.item)">
                            <td>{{props.item.name}}</td>
                            <td>{{props.item.group.name}}</td>
                            <td>{{props.item.type.name}}</td>
                            <td>{{props.item.group.name}}</td>
                          </tr>
                      </template>
                  </v-data-table>       
                  <v-pagination v-if="assetsMeta && assetsMeta.pagination && assetsMeta.pagination.count > 0"             
                      v-model="assetsMeta.pagination.current_page"
                      :length="assetsMeta.pagination.total_pages"                           
                      @input="loadPage">
                  </v-pagination>                  
                </v-flex>         
                <v-flex xs12 v-if="selectedMode=='assetGroup' && !showUnitTypeSelector">       
                  <v-data-table :headers="groupHeaders" :items="assetGroups" hide-actions>
                      <template slot="items" slot-scope="props">
                          <tr @click="selectAssetGroup(props.item)">
                            <td><i :class="props.item.icon"></i></td>
                            <td style="text-align:left;">{{props.item.name}}</td>
                            <td v-if="props.item.unitTypes">{{props.item.unitTypes.length}}</td>
                          </tr>
                      </template>
                  </v-data-table>       
                  <v-pagination v-if="assetGroupsMeta && assetGroupsMeta.pagination && assetGroupsMeta.pagination.count > 0"             
                      v-model="assetGroupsMeta.pagination.current_page"
                      :length="assetGroupsMeta.pagination.total_pages"                           
                      @input="loadAssetGroups">
                  </v-pagination>                   
                </v-flex>                             
                <v-flex xs12 v-if="selectedMode=='assetGroup' && showUnitTypeSelector"> 
                  <v-data-table :items="selectableUnitTypes" hide-actions>
                      <template slot="items" slot-scope="props">
                        <tr @click="selectedUnitType=props.item">
                          <td style="text-align:left;">{{props.item.name}}</td>
                        </tr>
                      </template>
                  </v-data-table>                                         
                </v-flex>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-btn color="primary" v-if="showUnitTypeSelector && !assetLocked" @click="showUnitTypeSelector=false; selectedUnitType=null"> Terug naar Assetgroep selectie</v-btn>
              <v-spacer></v-spacer>   
              <v-btn color="primary" @click="nextStep()" :disabled="!stepOneComplete"> Volgende stap</v-btn>                            
            </v-layout>        
          </v-stepper-content>
    <!-- STEP 2: POINT OF INTEREST SELECTION ---------------------------------------------------------------------------------------->
          <v-stepper-content step="2">
            <v-layout column>
                <v-flex xs12 mb-2>
                  <h4>Stap 2: Kies een Point of interest</h4>
                </v-flex>
                <v-flex>
                  <search-geo-zone ref="searchGeoZoneComp" @itemSelected="geoZoneSelected"></search-geo-zone>
                </v-flex>
            </v-layout>
            <v-layout row>
              <v-btn color="primary" @click="previousStep()" :disabled="assetLocked || (selectedMode=='assetGroup' && selectableUnitTypes.length>1)"> Vorige stap</v-btn>                            
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="openCreateGeoZone()">POI toevoegen</v-btn>
              <v-btn color="primary" @click="nextStep()" :disabled="!stepTwoComplete"> Volgende stap</v-btn>                            
            </v-layout>
          </v-stepper-content>
    <!-- STEP 3: POINT OF INTERESET SELECTION ---------------------------------------------------------------------------------------->
          <v-stepper-content step="3">  
              <v-flex xs12 mb-2>
                <h4>Stap 3: Events instellen</h4>
              </v-flex>  
              <v-flex v-if="assetHasGeoZoneEvent" xs12 pt-2 pb-2>
                  <i class="fas fa-check" style="color:green;"></i>
                  <span style="color:green; font-weight:bold;"> Point of interest event is gekoppeld aan asset</span>
              </v-flex>               
              <v-flex xs12 pl-4 pt-2>
                <label>Kies hieronder minimaal 1 event die u wilt registreren.</label>
              </v-flex>  
              <v-flex xs12 pa-4>
                  <v-layout column justify-center>
                      <v-layout row align-center>     
                        <v-flex xs1>
                          <v-checkbox
                            v-model="enterEvent"       
                            input-value="1"
                          >
                          </v-checkbox>                                                                      
                        </v-flex>                 
                        <v-flex>
                          Registreer als {{selectedSubject}} is aangekomen op lokatie {{selectedGeoZoneName}}
                        </v-flex>
                      </v-layout>
                      <v-layout row align-center>      
                          <v-flex xs1>
                            <v-checkbox
                              v-model="exitEvent"       
                              input-value="1"                                            
                            >
                            </v-checkbox>                        
                          </v-flex>                                          
                          <v-flex>
                            Registreer als {{selectedSubject}} lokatie {{selectedGeoZoneName}} heeft verlaten
                          </v-flex>                      
                      </v-layout>                    
                  </v-layout>
              </v-flex>          
            <v-layout row>
              <v-btn color="primary" @click="previousStep()" :disabled="step3PreviousButtonBlocked">Vorige stap</v-btn>        
              <v-spacer></v-spacer>                                    
              <v-btn color="primary" @click="nextStep()" :disabled="step3NextButtonBlocked"> Volgende stap</v-btn>                                                  
            </v-layout>
          </v-stepper-content>
    <!-- STEP 4: TIME PERIOD SELECTION ---------------------------------------------------------------------------------------->        
          <v-stepper-content step="4">  
              <v-flex xs12 mb-2>
                <h4>Stap 4: Tijdsperiode instellen</h4>
              </v-flex>            
              <v-flex xs12 pa-2>
                <v-layout column>
                  <v-flex xs12>
                    <label>Voor welke tijdperiode moet de POI actief zijn?</label>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout row wrap align-center>
                      <v-flex xs3 style="min-height:136px;">
                        <v-radio-group v-model="timePeriod" :mandatory="true">
                          <v-radio label="Altijd" value="always"></v-radio>
                          <v-radio label="Kies periode" value="period"></v-radio>
                        </v-radio-group>                                        
                      </v-flex>                    
                      <v-flex xs9 v-if="timePeriod=='period'">
                        <v-layout row>
                            <date-picker v-model="dateFrom" label="Actief vanaf (optioneel)"></date-picker>        
                        </v-layout>
                        <v-layout row>
                            <date-picker v-model="dateTill" label="Actief tot (optioneel)"></date-picker>        
                        </v-layout>                      
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <label>Wanneer moeten POI events registreren?</label>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout row wrap align-center>
                      <v-flex xs3 style="min-height:136px;">
                        <v-radio-group v-model="timeTableActive" :mandatory="true">
                          <v-radio label="Altijd" value="no"></v-radio>
                          <v-radio label="Kies tijdtabel" value="yes"></v-radio>
                        </v-radio-group>                                        
                      </v-flex>                    
                      <v-flex xs3 v-show="timeTableActive=='yes'">
                        <v-layout row>      
                          <v-select
                            :items="timeTableOperators"
                            item-value="id"
                            item-text="name"          
                            label="Binnen/Buiten"
                            v-model="selectedTimeTableOperator"
                          ></v-select>                         
                        </v-layout>                         
                        <v-layout row>
                          <v-select
                            :items="timeTables"
                            item-value="id"
                            item-text="name"          
                            label="Tijdtabel"
                            v-model="selectedTimeTable"
                          ></v-select> 
                        </v-layout>                   
                      </v-flex>
                    </v-layout>                                     
                  </v-flex>                
                </v-layout>
              </v-flex>
              <v-flex xs12 mb-2>    
                <v-layout row>
                  <v-btn color="primary" @click="previousStep()"> Vorige stap</v-btn>      
                  <v-spacer></v-spacer>        
                  <v-btn v-if="assetHasGeoZoneEvent" color="primary" @click="removeGeoZoneFromAsset()">POI loskoppelen van asset</v-btn>
                  <v-btn v-if="assetHasGeoZoneEvent" color="primary" @click="close()">Afsluiten</v-btn>
                  <v-btn v-if="!assetHasGeoZoneEvent" color="primary" @click="complete()" :disabled="completeBlocked"> Voltooien</v-btn>                    
                </v-layout>
              </v-flex>
          </v-stepper-content>    
        </v-stepper-items>
      </v-stepper>
      <v-dialog max-width="800px"  persistent v-model="createGeoZoneOpen"  v-if="createGeoZoneOpen">     
          <v-card>
              <v-card-title :class="`modal-title-bar`" >
                  <h4>Maak Point of interest aan</h4>
                  <v-spacer></v-spacer>
                  <i class="fas fa-times fa-2x" style="cursor:pointer;" @click="createGeoZoneOpen=false"></i>                                
              </v-card-title>                        
          </v-card>       
          <create-geo-zone @isSaved="PoiIsCreated" @close="createGeoZoneOpen=false"></create-geo-zone>
      </v-dialog>    
    </v-flex>
</template>
<script>
    import * as types from "../../store/types"
    import { mapGetters } from 'vuex'
    import searchMixin from "../../plugins/mixins/SearchWithPagerMixin.js"
    import SearchGeoZone from "../../components/geozone/SearchGeoZone"
    import CreateGeoZone from "../../components/map/CreateGeoZone"
    import DatePicker from "../../components/form/DatePicker"
import { PolyUtil, Projection } from 'leaflet';
    export default {
        components:{
          SearchGeoZone,
          CreateGeoZone,
          DatePicker
        },
        mixins:[searchMixin],
        data() {
          return {
              timeTableOperators:[
                  {id:"inside", name:"Binnen"},
                  {id:"outside", name:"Buiten"}                  
              ],     
              createGeoZoneOpen:false,
              showUnitTypeSelector:false,
              selectedMode:"choose",         
              selectedTimeTableOperator:"inside",
              selectedTimeTable:null,
              timeTableActive:"no",
              dateFrom:null,
              dateTill:null,
              timePeriod:"always",              
              enterEvent:0,
              exitEvent:0,              
              completeBlocked:false,
              selectedChanged:false,
              searchTerm:"",
              currentStep: 1,
              assetLocked:false,
              geoZoneLocked:false,
              selectedUnitType:null,
              selectedAsset:null,
              selectedAssetGroup:null,
              selectedGeoZone:null,
              selectedGeoZoneEvent:null,
              selectedGeoZoneEventPreset:null,
              selectedAssetGeoZoneEventId:null,
              selectedAssetGroupGeoZoneEventId:null,
              gridHeaders: [
                  { text: "Naam", sortable: false },
                  { text: "type", sortable: false },
                  { text: "groep", sortable: false },
                  { text: "unit type", sortable: false }
              ], 
              groupHeaders:[
                  { text: "", sortable: false },
                  { text: "Assetgroep", sortable: false },
                  { text: "hardware typen in groep", sortable: false }                
              ]                 
          }
        },      
        props: {
          geoZone: {
            type: Object,
          },
          asset:{
            type:Object,
          },
          assetGroup:{
            type:Object
          },
          assetGeoZoneEvent:{
            type:Object,
          },
          assetGroupGeoZoneEvent:{
            type:Object,
          },
          mode:{
            type:String,
            default:"choose"
          }
        },
        computed: {
          ...mapGetters({
              assets: types.ASSETS_SEARCH,
              assetGroups:types.ASSET_GROUPS,
              assetGroupsMeta:types.ASSET_GROUPS_META,
              assetsMeta: types.ASSETS_SEARCH_META,
              storeAsset: types.ASSET,
              timeTables: types.TIME_TABLES,
              predefinedEvents: types.PREDEFINED_EVENTS              
          }),            
          selectableUnitTypes(){
            return this.selectedAssetGroup ? this.selectedAssetGroup.unitTypes : []
          },
          stepOneTarget(){
            if(this.selectedMode == "asset"){
              return "Kies een asset"              
            }
            else if(this.selectedMode == "assetGroup"){
              if(this.showUnitTypeSelector)
                return "Kies een hardwaretype"
              else
                return "Kies een assetgroep"
            }
            else if(this.selectedMode == "choose"){
              return "Maak een keuze tussen asset of assetgroep"
            }
          },  
          stepOneTargetHeader(){
            if(this.selectedMode == "asset"){
              return "Asset"              
            }
            else if(this.selectedMode == "assetGroup"){
              return "Assetgroep"
            }
            else if(this.selectedMode == "choose"){
              return "Asset/Assetgroep"
            }
          },  
          stepOneChoice() {
            if(this.selectedMode == "asset")
              return this.selectedAsset ? this.selectedAsset.name : "Maak een keuze"
            if(this.selectedMode == "assetGroup")
              return this.selectedAssetGroup && this.selectedUnitType ? this.selectedAssetGroup.name+"/"+this.selectedUnitType.name : "Maak een keuze"              
          },          
          stepOneComplete(){
            if(this.selectedMode == "asset")            
              return this.selectedAsset ? true : false
            if(this.selectedMode == "assetGroup")            
              return this.selectedAssetGroup && this.selectedUnitType ? true : false              
          },      
          stepTwoChoice() {
            return this.selectedGeoZone ? this.selectedGeoZone.name : "Maak een keuze"
          },
          stepTwoComplete(){
            return this.selectedGeoZone ? true : false
          },  
          stepThreeChoice(){
             let choices = []  
             if(this.enterEvent == 1)
              choices.push("in")
             if(this.exitEvent == 1)  
              choices.push("uit")
          
             if(choices.length == 2)
              return choices.join("/")+" events registreren"
             else if(choices.length == 1)
              return choices[0]+" event registreren"
             else
              return "Maak een keuze"
          },  
          stepFourChoice(){
              return "Maak een keuze"
          },              
          stepThreeComplete() {            
            return this.currentStep == 4 ? true : false
          },
          step3NextButtonBlocked(){
            return (this.exitEvent + this.enterEvent) == 0 ? true:false
          },
          step3PreviousButtonBlocked(){
            // dont allow changing asset/assetgroup and poi when in edit mode
            if(this.selectedAssetGeoZoneEventId || this.selectedAssetGroupGeoZoneEventId){
              return true;
            }
            return this.assetGeoZoneEvent ? true : false
          },
          selectedAssetUnitTypeName(){
             return  this.selectedAsset ? this.selectedAsset.unitType.name : "  "
          },             
          selectedSubject(){
             if(this.selectedMode == "assetGroup")
                return  this.selectedAssetGroup ? " een asset in groep "+this.selectedAssetGroup.name : " [selecteer assetgroep] "
             else
                return  this.selectedAsset ? this.selectedAsset.name : " [selecteer asset] "
          },
          selectedGeoZoneName(){
             return  this.selectedGeoZone ? this.selectedGeoZone.name : "[selecteer point of interest]"
          },
          assetHasGeoZoneEvent(){
            let vm = this
            let result = false
            if(this.selectedAsset && this.selectedAsset.geoZoneEvents && this.selectedGeoZone){                  
                this.selectedAsset.geoZoneEvents.forEach((event) => {                    
                    if(event.geoZone.id == vm.selectedGeoZone.id){
                      result = event.id
                    }
                })
            }
            return result
          }
        },
        methods: {
          getUnitType(){              
              return  (this.selectedMode == "asset") ? this.selectedAsset.unitType : this.selectedUnitType
          },           
          getPredefinedGeoZoneEvent(){
              if(this.predefinedEvents.length == 0){
                  return {}
              }

              let geoEvent = {}
              let pe = this.predefinedEvents.find( (el) => el.predefinitionName == 'geo_zone_event')
              
              if(!pe){
                return {}
              }

              console.log("DEZE IS GEVONDEN", pe)

              geoEvent.iotCode           = this.getUnitType().positionEvent
              geoEvent.internalEventName = pe.internalEventName
              geoEvent.iotEvent          = true
              geoEvent.active            = true
              geoEvent.eventTypeId       = pe.type.id
              geoEvent.predefinedEventId = pe.id

              return geoEvent
          },          
          PoiIsCreated(poi){            
              this.geoZoneSelected(poi)
              this.$refs.searchGeoZoneComp.reset(true);
              this.createGeoZoneOpen = false;                         
              this.selectStep(3);              
          },
          selectAsset(asset){
              // make sure selectedChanged is set if another asset is selected to reload presets on step 3
              if(!this.selectedAsset || this.selectedAsset.id != asset.id)
                this.selectedChanged = true

              this.selectedAsset = asset
          },
          selectAssetGroup(assetGroup){
              // if selection has changed 
              if(!this.selectedAssetGroup || this.selectedAssetGroup.id != assetGroup.id){
                this.selectedChanged  = true            
                this.selectedUnitType = null
              }                          
              this.selectedAssetGroup = assetGroup

              // if more then one unit type is available let user select, otherwise set selected
              if(assetGroup.unitTypes.length > 1){
                this.showUnitTypeSelector=true;
              }
              else{
                this.selectedUnitType = assetGroup.unitTypes[0]
              }
          },
          geoZoneSelected(zone){           
              if(!this.selectedGeoZone || this.selectedGeoZone.id != zone.id)
                this.selectedChanged = true            
            
              this.selectedGeoZone = zone
          },
          previousStep(){
              if(this.currentStep == 3 && this.geoZoneLocked){
                  this.selectStep(1)
              }
              if(this.currentStep == 3){
                  this.selectStep(2)
              }              
              if(this.currentStep == 2 && !this.assetLocked){
                 this.selectStep(1)
              }
              if(this.currentStep == 4){
                this.selectStep(3)    
              }
          },
          nextStep() {
              if(this.currentStep == 1 && this.stepTwoComplete && this.geoZoneLocked){
                  this.selectStep(3)
              }
              else if(this.currentStep == 1){
                this.selectStep(2)
              }
              else if(this.currentStep == 2){
                  this.selectStep(3)
              }      
              else if(this.currentStep == 3){
                  this.selectStep(4)
              }                        
          },
          selectStep(newStep){
              this.currentStep = newStep
              if(this.currentStep == 3){
                  this.loadThirthEventStep()
              }
          },
          loadStartStep(){
            this.$nextTick(() => {
                if(this.assetGeoZoneEvent || this.assetGroupGeoZoneEvent){
                  this.selectStep(3)
                }
                else if(this.selectedAssetGroup && this.selectedUnitType){
                  this.selectStep(2)
                }                   
                else if(this.asset && this.geoZone){
                  this.selectStep(3)
                }
                else if(this.asset && !this.geoZone){
                  this.selectStep(2)
                }             
                else{
                  this.selectStep(1)
                }
            })            
          },          
          loadThirthEventStep(){
              // only reload if selected was changed
              // Prepare everything for saving from the right route
              if(this.selectedChanged){
                  this.selectedGeoZoneEvent=null
                  this.selectedGeoZoneEventPrefix=null
                  this.completeBlocked = true
          
                  let vm = this                  
                
                  // TODO: REFACTOR THIS INTO MORE TO ONE FUNCTIONALITY WORKING WITH ASSET_GEOZONE_EVENTS INSTEAD OF GEOZONE_EVENTS
                  let geoZoneEvent = false
                  //let geoZoneEvent = this.selectedAsset.assetGeoZoneEvents.find(x => x.id == vm.selectedGeoZone.id)                

                  // geoZoneEvent found no use to search any further, got everything to couple geozone to event
                  /* Not needed anymore never comes here 
                  if(geoZoneEvent){
                    vm.completeBlocked = false
                    vm.selectedChanged = false // set back to false                  
                    this.selectedGeoZoneEvent = geoZoneEvent    
                  }*/

                  // if hooked to assetgroup gather information on which unittypes are available
                  // collect available events for this unit type and geo zone to create geozone event                      
                  this.loadGeoZoneEventForUnitTypeAndGeoZone().then((event) => {                  
                      if(event && event.length > 0){ // has been fount for unit type id and geozone id
                            // for now it is threated as 1 on 1 relation, while it soon will change to one (geozone) to many (events)
                            event = event[0]
                            vm.completeBlocked = false
                            vm.selectedChanged = false // set back to false 
                            vm.selectedGeoZoneEvent=event
                      }
                      else{ // use hardware preset to create new geozone event
                        let event = vm.getPredefinedGeoZoneEvent()
                        if(event){                    
                          vm.completeBlocked   = false
                          this.selectedChanged = false // set back to false 
                          vm.selectedGeoZoneEventPreset=event
                        }
                        else{
                          vm.showErrorMessage("no geozone predefined event found")                              
                        }                          
                      }                          
                  })                                             
              }
          },
          loadGeoZoneEventForUnitTypeAndGeoZone(){

              let unitTypeId = this.getUnitType().id

              return this.$store.dispatch(types.GEO_ZONE_EVENTS_ON_UNIT_TYPE_AND_GEO_ZONE, 
                  {data:{unitTypeId:unitTypeId,geoZoneId:this.selectedGeoZone.id},
                  params:{include:"geoZone,enterEvent,exitEvent"}}
              )
          },
          showErrorMessage(e){              
              this.$notify('Niet mogelijk om deze combinatie te koppelen. Neem contact met de beheerder', { icon: 'error', type: 'error'})
          },
          complete(){           
              // just update on saved (group)        
              if(this.selectedAssetGroupGeoZoneEventId){
                this.coupleGeoZoneEventOnAssetGroup(this.selectedGeoZoneEvent.id, this.selectedAssetGroup.id, this.selectedAssetGroupGeoZoneEventId)
              }
              // just update on saved (asset)
              else if(this.selectedAssetGeoZoneEventId){
                this.coupleGeoZoneEventOnAsset(this.selectedGeoZoneEvent.id, this.selectedAsset.id, this.selectedAssetGeoZoneEventId)
              }             
              // create geo zone event based on hardware event presets
              else if(this.selectedGeoZoneEventPreset){ 
                  this.createGeoZoneEventOnPreset()
              }                
              // couple the geo zone event on asset
              else if(this.selectedMode == "asset" && this.selectedGeoZoneEvent){ 
                  this.coupleGeoZoneEventOnAsset(this.selectedGeoZoneEvent.id, this.selectedAsset.id)
              }
              // couple the geo zone event on assetGroup
              else if(this.selectedMode == "assetGroup" && this.selectedGeoZoneEvent){ 
                  this.coupleGeoZoneEventOnAssetGroup(this.selectedGeoZoneEvent.id, this.selectedAssetGroup.id)
              }              
          },
          createGeoZoneEventOnPreset(){
              let vm = this
              let pArr = []

              // Always create enter and leave events                            
              pArr.push( vm.createEventOnPreset("enter"))
              pArr.push(vm.createEventOnPreset("exit"))
              
              Promise.all(pArr).then((res) => {                              
                let store = {}
                store.geoZoneId = vm.selectedGeoZone.id
                
                if(this.enterEvent == 1)
                  store.onEnterUnitTypeEventId = res[0].id
                if(this.exitEvent == 1)
                  store.onExitUnitTypeEventId = res[1].id
            
                this.$store.dispatch(types.SAVE_GEO_ZONE_EVENT, {data:store} ).then((res) => { 
                     let geoZoneEventId = res.id

                     if(vm.selectedMode == "asset")
                        vm.coupleGeoZoneEventOnAsset(geoZoneEventId, vm.selectedAsset.id)
                     else
                        vm.coupleGeoZoneEventOnAssetGroup(geoZoneEventId, vm.selectedAssetGroup.id)
                })         
              }).catch((e) => {
                vm.showErrorMessage(e)                                
              })
          },
          createEventOnPreset(type){              
              this.selectedGeoZoneEventPreset.unitTypeId = this.getUnitType().id

              let event     = {}
              let enterText = `Op POI ${this.selectedGeoZone.name} aangekomen`
              let exitText  = `POI ${this.selectedGeoZone.name} verlaten`

              Object.assign(event, this.selectedGeoZoneEventPreset)    
              if(type == "enter"){                
                event.name      = enterText
                event.shortText = enterText
              }
              if(type == "exit"){
                event.name      = exitText
                event.shortText = exitText                
              }
              return this.$store.dispatch(types.SAVE_UNIT_TYPE_EVENT, {data:event})
          },           
          coupleGeoZoneEventOnAsset(geoZoneEventId, assetId,assetGeoZoneEventId=false){
            let vm = this

            /* GEO ZONE EVENT */
            let assetGeoZoneEvent                = {}

            if(!assetGeoZoneEventId){
              assetGeoZoneEvent.assetId          = assetId
              assetGeoZoneEvent.geoZoneEventId   = geoZoneEventId
            }
            else{
              assetGeoZoneEvent.id               = assetGeoZoneEventId
            }

            assetGeoZoneEvent.enterEventActive = this.enterEvent == 1 ? true : false
            assetGeoZoneEvent.exitEventActive  = this.exitEvent == 1 ? true : false        
            
            // if timeperiod is always, set values back to null 
            assetGeoZoneEvent.activeFrom       = this.timePeriod != "always" ? this.dateFrom : null
            assetGeoZoneEvent.activeTill       = this.timePeriod != "always" ? this.dateTill : null
            
            assetGeoZoneEvent.timeTableZone    = this.timeTableActive == "yes" ? this.selectedTimeTableOperator : null;
            assetGeoZoneEvent.timeTableId      = this.timeTableActive == "yes" ? this.selectedTimeTable : null;

            this.$store.dispatch(types.SAVE_ASSET_GEO_ZONE_EVENT, {data:assetGeoZoneEvent}).then((res) => {
              
              let txt =  assetGeoZoneEventId ? " aangepast op " : " gekoppeld aan "

              vm.$notify("POI "+this.selectedGeoZone.name+txt+"aan "+this.selectedAsset.name, { icon: 'check', type: 'success'})
              vm.handleSuccesfullComplete()            
            }).catch((e) => {
              vm.showErrorMessage(e)   
            })                
          },
          coupleGeoZoneEventOnAssetGroup(geoZoneEventId, assetGroupId,assetGroupGeoZoneEventId=false){
              let vm = this

              /* GEO ZONE EVENT */
              let assetGroupGeoZoneEvent                = {}

              if(!assetGroupGeoZoneEventId){
                assetGroupGeoZoneEvent.assetGroupId     = assetGroupId
                assetGroupGeoZoneEvent.geoZoneEventId   = geoZoneEventId
              }
              else{
                assetGroupGeoZoneEvent.id               = assetGroupGeoZoneEventId
              }

              assetGroupGeoZoneEvent.enterEventActive = this.enterEvent == 1 ? true : false
              assetGroupGeoZoneEvent.exitEventActive  = this.exitEvent == 1 ? true : false        
              
              // if timeperiod is always, set values back to null 
              assetGroupGeoZoneEvent.activeFrom       = this.timePeriod != "always" ? this.dateFrom : null
              assetGroupGeoZoneEvent.activeTill       = this.timePeriod != "always" ? this.dateTill : null
              
              assetGroupGeoZoneEvent.timeTableZone    = this.timeTableActive == "yes" ? this.selectedTimeTableOperator : null
              assetGroupGeoZoneEvent.timeTableId      = this.timeTableActive == "yes" ? this.selectedTimeTable : null
              assetGroupGeoZoneEvent.unitTypeId       = this.selectedUnitType.id

              this.$store.dispatch(types.SAVE_ASSET_GROUP_GEO_ZONE_EVENT, {data:assetGroupGeoZoneEvent}).then((res) => {
                
                let txt =  assetGroupGeoZoneEventId ? " aangepast op " : " gekoppeld aan "

                vm.$notify("POI "+this.selectedGeoZone.name+txt+"aan groep "+this.selectedAssetGroup.name, { icon: 'check', type: 'success'})
                vm.handleSuccesfullComplete()            
              }).catch((e) => {
                vm.showErrorMessage(e)   
              })                
          },          
          handleSuccesfullComplete(){   
              
              if(this.selectedMode == 'asset'){         
                this.loadSelectedAssetFromStore(this.selectedAsset.id).then(() => {
                  this.selectedAsset = this.storeAsset
                })
              }
              this.$emit('isSaved')
          },
          close(){
            this.$emit('close');   
          },
          getEventTypeId(type){

          },
          removeGeoZoneFromAsset(){
            let geoZoneEventId = this.assetHasGeoZoneEvent
            let assetId = this.selectedAsset.id
            let vm = this
            
            this.$store.dispatch(types.DELETE_ASSET_GEO_ZONE_EVENT, {data:{geoZoneEventId:geoZoneEventId,assetId:assetId}})                
            .then(()=>{
                vm.$notify('POI koppeling succesvol verwijderd', { icon: 'check', type: 'success'})    
                this.handleSuccesfullComplete()                
            })
          },
          loadWizardOnAssetGeoZoneEvent(){
              this.loadOutWizardOnMode("asset")
          },
          loadWizardOnAssetGroupGeoZoneEvent(){
            this.loadOutWizardOnMode("assetGroup")
          },
          loadOutWizardOnMode(mode){
              this.selectedMode = mode

              let source = (mode == "asset") ? "assetGeoZoneEvent" : "assetGroupGeoZoneEvent"

              // lock items
              this.geoZoneLocked = true              
              this.assetLocked   = true

              // load objects
              if(mode == 'asset'){      
                  this.selectedAssetGeoZoneEventId = this[source].id            
              }
              else if(mode == 'assetGroup'){
                  this.selectedAssetGroupGeoZoneEventId = this[source].id   
                  this.selectedUnitType            = this[source].unitType         
              }

              this.selectedGeoZone      = this[source].geoZoneEvent.geoZone

              this.selectedGeoZoneEvent = this[source].geoZoneEvent   

              // load form values
              this.enterEvent                  = this[source].enterEventActive ? true : false
              this.exitEvent                   = this[source].exitEventActive ? true : false

              if(this[source].activeFrom || this[source].activeTill){
                this.timePeriod = "period"
                this.dateFrom   = this[source].activeFrom ? this[source].activeFrom.split(" ")[0] : null
                this.dateTill   = this[source].activeTill ? this[source].activeTill.split(" ")[0] : null
              }
              
              if(this[source].timeTable){
                this.timeTableActive   = "yes";
                this.selectedTimeTable = this[source].timeTable.id
                this.timeTableZone     = this[source].timeTable.timeTableZone 
              }
          },
          loadTimeTables(){
            return this.$store.dispatch(types.TIME_TABLES,{})
          },          
          loadSelectedAssetFromStore(assetId){
              let vm = this
              return this.$store.dispatch(types.ASSET, { data: { id: assetId }, params: { include: "type,group,unitType,geoZoneEvents, geoZoneEvents.geoZone"}})                                                    
          },          
          loadPredefinedEvents(){
              // if predefined event is not set then return 
              if(this.predefinedEvents.length == 0){
                this.$store.dispatch(types.PREDEFINED_EVENTS,{params:{include:"type" ,predefinationName:"geo_zone_event"}}).then((res) => {})  
              }
          },          
          loadAssetGroups(pageNr=1){
            return this.$store.dispatch(types.ASSET_GROUPS,{params:{include:"unitTypes",page:pageNr}})
          },          
          loadSelectedAssetGroupFromStore(assetGroupId){
            return this.$store.dispatch(types.ASSET_GROUP,{params:{include:"unitTypes"},data:{groupId:assetGroupId}})
          },    
          openCreateGeoZone(){
            this.createGeoZoneOpen=true
          }
        },
        mounted(){
            let vm = this

            // configure mixin
            this.searchMixin.perPage              = 5
            this.searchMixin.payloadDataSearchKey = "searchTerm"
            this.searchMixin.payloadData          = {}
            this.searchMixin.payloadIncludes      = "type,group,unitType,geoZoneEvents, geoZoneEvents.geoZone"
            this.searchMixin.searchStore          = types.ASSETS_SEARCH
            this.searchMixin.defaultStore         = types.ASSETS_SEARCH
            this.loadPredefinedEvents();
            this.loadTimeTables().then(() => {

                // for now if prop assetGeoZoneEvent is set asume that this prop is given with asset, geoZoneEvent and geoZoneEvent.geoZone
                if(this.assetGeoZoneEvent){
                  this.loadSelectedAssetFromStore(this.asset.id).then(() => {
                    vm.selectedAsset =  vm.storeAsset
                    vm.loadStartStep()
                    vm.loadWizardOnAssetGeoZoneEvent()
                  })                  
                } 
                // for now if prop assetGroupGeoZoneEvent is set asume that this prop is given with assetGroup, unitType, geoZoneEvent and geoZoneEvent.geoZone
                else if(this.assetGroupGeoZoneEvent){          
                  this.loadSelectedAssetGroupFromStore(this.assetGroupGeoZoneEvent.assetGroup.id).then((res) => {                  
                    this.selectAssetGroup(res)
                    vm.loadStartStep()
                    vm.loadWizardOnAssetGroupGeoZoneEvent()
                  })                                     
                }
                else{
                    // lock geozone if set from prop
                    if(this.geoZone){
                      this.selectedGeoZone = this.geoZone
                      this.geoZoneLocked = true
                    }
                  
                    // lock asset if set from prop (and retrieve with needed relations)
                    if(this.asset){
                      this.selectedMode = 'asset'
                      this.assetLocked = true
                      this.loadSelectedAssetFromStore(this.asset.id).then(() => {
                        vm.selectedAsset =  vm.storeAsset
                        vm.loadStartStep()
                      })    
                    }
                    else if(this.assetGroup){ // load next step
                      this.selectedMode = 'assetGroup'
                      this.assetLocked = true
                      this.loadSelectedAssetGroupFromStore(this.assetGroup.id).then((res) => {
                        this.selectAssetGroup(res)     
                        this.loadStartStep()          
                      })
                    }
                    else{

                      this.loadAssetGroups()

                      // if mode is given as prop set the selectedMode
                      if(this.mode){
                        this.selectedMode = this.mode
                      }
                      
                      this.loadStartStep()
                    }
                }
            })   

        }
    }
</script>

<style scoped>

</style>